import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_component_option_compatibility_hdr_RowClass, bl_fi_mto_component_option_compatibility_line_RowClass} from '../../../dbschema';

export class MTOComponentOptionCompatibilityContainerModel extends BaseContainerModel {

  bl_fi_mto_component_option_compatibility_hdr: bl_fi_mto_component_option_compatibility_hdr_RowClass = new bl_fi_mto_component_option_compatibility_hdr_RowClass();
  bl_fi_mto_component_option_compatibility_lines: bl_fi_mto_component_option_compatibility_line_RowClass[] = [];
}
